<admin-navigation>
  <router-outlet />
</admin-navigation>
